import React, { useState, useEffect } from 'react';
import AddEmployeeForm from '../../Component/employee/AddEmployeeForm';
import EditEmployeeForm from '../../Component/employee/EditEmployeeForm';
import apiClient from '../../apiClient';

const EmployeeDetails = () => {
  const [employees, setEmployees] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editingEmployee, setEditingEmployee] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEmployees = async () => {
    try {
      const response = await apiClient.get('/api/employees');
      console.log('Fetched employees:', response.data);
      setEmployees(Array.isArray(response.data) ? response.data : []);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching employees:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  const handleAddEmployee = async (newEmployee) => {
    try {
      const response = await apiClient.post('/api/employees', newEmployee);
      setEmployees([...employees, response.data]);
      setShowAddForm(false);
    } catch (error) {
      console.error('Error adding employee:', error);
    }
  };

  const handleEditClick = (employee) => {
    setEditingEmployee(employee);
    setShowEditForm(true);
  };

  const handleUpdateEmployee = async (updatedEmployee) => {
    try {
      const response = await apiClient.put(`/api/employees/${updatedEmployee.id}`, updatedEmployee);
      setEmployees(employees.map(emp => (emp.id === updatedEmployee.id ? response.data : emp)));
      setShowEditForm(false);
      setEditingEmployee(null);
    } catch (error) {
      console.error('Error updating employee:', error);
    }
  };

  const handleDeleteEmployee = async (employeeId) => {
    if (!window.confirm('Are you sure you want to delete this employee?')) return;
    try {
      await apiClient.delete(`/api/employees/${employeeId}`);
      setEmployees(employees.filter(emp => emp.id !== employeeId));
    } catch (error) {
      console.error('Error deleting employee:', error);
    }
  };

  return (
    <div className="employee-details-page">
      <h1>Employee Details</h1>
      <button onClick={() => setShowAddForm(true)}>Add Employee</button>

      {showAddForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Add New Employee</h2>
              <button onClick={() => setShowAddForm(false)} className="close-btn">
                &times;
              </button>
            </div>
            <AddEmployeeForm onSuccess={handleAddEmployee} onCancel={() => setShowAddForm(false)} />
          </div>
        </div>
      )}

      {showEditForm && editingEmployee && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Edit Employee</h2>
              <button onClick={() => setShowEditForm(false)} className="close-btn">
                &times;
              </button>
            </div>
            <EditEmployeeForm
              employee={editingEmployee}
              onSuccess={handleUpdateEmployee}
              onCancel={() => setShowEditForm(false)}
            />
          </div>
        </div>
      )}

      <div className="employee-list">
        {isLoading ? (
          <p>Loading employees...</p>
        ) : employees.length === 0 ? (
          <p>No employees found.</p>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp) => (
                <tr key={emp.id}>
                  <td>{emp.name}</td>
                  <td>{emp.email}</td>
                  <td>{emp.phone}</td>
                  <td>
                    <button onClick={() => handleEditClick(emp)}>Edit</button>
                    <button onClick={() => handleDeleteEmployee(emp.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default EmployeeDetails;
